import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import type { ApolloError } from '@apollo/client'
import type { TaskActionHookType } from '@ztechapps/common.contract'

export const taskActionHooksQuery = gql`
  query taskActionHooks {
    taskActionHooks {
      id
      name
      description
      parameterSchema
    }
  }
`

export type UseTaskActionHooksProps = {
  skip?: boolean
}

export type UseTaskActionHooksResult = {
  hooks: TaskActionHookType[]
  loading: boolean
  error?: ApolloError
  refetch: () => Promise<unknown>
}

export const useTaskActionHooks = ({ skip = false }: UseTaskActionHooksProps = {}): UseTaskActionHooksResult => {
  const { data, loading, error, refetch } = useQuery<{ taskActionHooks: TaskActionHookType[] }>(taskActionHooksQuery, {
    skip,
    fetchPolicy: 'cache-and-network',
  })

  return {
    hooks: data?.taskActionHooks ?? [],
    loading,
    error,
    refetch,
  }
}
